var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"full-image"},[_c('div',{staticClass:"mask",on:{"click":_vm.close}}),_c('div',{staticClass:"image-box"},[(_vm.displayUrl)?_c('img',{attrs:{"src":_vm.displayUrl},on:{"load":_vm.onImageLoad}}):_vm._e()]),_c('div',{staticClass:"close",on:{"click":_vm.close}},[_c('i',{staticClass:"el-icon-close"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }